export const getIsImraUser = (hasFeature: (name: string) => boolean): boolean =>
  hasFeature("has_texas_ela_license");
